module.exports = __webpack_public_path__ + "static/media/certificate-complete-3.c5b813ab.svg";